import { useFormik } from "formik";
import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from "react-dropdown-select";


interface Tag {
  tagId: number,
  tagName: string
}
interface LinkNewTagModalFormProps {
  onCreateNewTag: (userDetails: any) => void;
  tagListForDropdown: Tag[]
}

const LinkNewTagModalForm: React.FC<LinkNewTagModalFormProps> = ({
  onCreateNewTag,
  tagListForDropdown,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      tagIds: [],
    },
    onSubmit: (values, { resetForm }) => {
      onCreateNewTag(values);
      resetForm();
      handleModalClose();
    },
  });



  return (
    <>
      <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
        Link New Tag
      </Button>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{"Add New Tag"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="findState">
              <Form.Label>Website Tag</Form.Label>
              <Select
                required
                options={tagListForDropdown}
                labelField="tagName"
                valueField="tagId"
                searchable
                searchBy={"tagName"}
                values={formik.values.tagIds} // Ensure it's an array
                onChange={(selectedValues) => {
                  formik.setFieldValue(
                    "tagIds",
                    selectedValues.map((item) => item.tagId)
                  ); // Correct way to update Formik
                }}
                onClearAll={() => formik.setFieldValue("stateIds", [])}
                multi
                selectAll
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {"Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LinkNewTagModalForm;
